import { Icon } from '@iconify/react/dist/iconify.js';
import React, { useContext } from 'react';
import { useHistory } from 'react-router-dom';
import BackIcon from '../../../../assets/BackIcon';
import { WebsiteLayout } from '../../../../components/Layouts/WebsiteLayout';
import { toast } from 'react-toastify';
import { CartContext } from '../../../routes/Router';

const CartList = () => {
  const history = useHistory();

  const { cartItems, handleCartItems } = useContext(CartContext);

  const total =
    cartItems?.length > 0 &&
    cartItems.reduce((sum, item) => sum + Number(item?.svc_price_amt), 0);

  const handleClearCart = async () => {
    try {
      handleCartItems([]);
      localStorage.removeItem('cartData');
      toast.success('Cart has been cleared');
    } catch (error) {
      toast.error(error.message);
    }
  };

  const goToExplore = () => {
    history.push('/');
  };

  const deleteCartItem = async (index) => {
    try {
      const updatedCartItems = cartItems.filter((_, idx) => idx !== index);
      handleCartItems(updatedCartItems);
      toast.success('Shopping cart update successful');
    } catch (error) {
      toast.error(error.message);
    }
  };
  return (
    <WebsiteLayout className={'bg-lightGray min-h-[60vh]'}>
      <div className="px-[0.75rem] sm:px-8 pt-15 flex items-center justify-between mb-3">
        <h5 className="text-base sm:text-[26px] w-full whitespace-wrap m-0">
          Cart ({(cartItems && cartItems.length) || 0})
        </h5>
        <button
          className="sign_btn !text-sm !font-medium !flex gap-1 !items-center !w-fit whitespace-nowrap h-[30px] px-3 sm:h-auto"
          onClick={(e) =>
            Array.isArray(cartItems) && cartItems.length > 0
              ? handleClearCart()
              : goToExplore()
          }
        >
          {Array.isArray(cartItems) && cartItems.length > 0
            ? 'Clear Cart'
            : 'Add Items to Cart'}
        </button>
      </div>

      {cartItems.length > 0 ? (
        <div className="flex md:flex-row flex-col lg:gap-16 gap-8  md:!px-9 !px-4 m-0 mt-5 pb-10">
          <div className="md:w-[70%] w-full">
            <div className="w-fit flex gap-2 items-center">
              <div className="text-white bg-[#1340CD] rounded-[5px] h-5 w-5 text-sm text-center"></div>
              <p className="m-0 text-sm text-[#1340CD] font-medium">
                Review selected services
              </p>
            </div>

            <div className="list mt-4 pb-4 ">
              {cartItems.map((item, index) => (
                <div className="border-b border-b-gray-300 pb-3" key={index}>
                  <div className="flex justify-between w-full items-center mt-2 ">
                    <div className="flex items-center gap-3">
                      <Icon
                        icon="streamline-emojis:hospital"
                        style={{ fontSize: '50px' }}
                      />
                      <div className="mt-3">
                        <h2 className="text-[18px] font-medium m-0">
                          #{item?.svc_id} {item?.svc_name}
                        </h2>
                        {item?.ord_svc_date && (
                          <h2 className="text-base font-medium m-0 text-gray-500">
                            {item?.ord_svc_date}, {item?.ord_svc_time}
                          </h2>
                        )}

                        {item.order_ship_instructions && (
                          <>
                            <span className="text-base font-medium">
                              Special Instructions:
                            </span>{' '}
                            <span className="text-gray-500">
                              {item.order_ship_instructions}
                            </span>
                          </>
                        )}
                      </div>
                    </div>

                    <div className="flex items-center gap-3 mt-[2px]">
                      <h4 className="text-[18px] font-semibold m-0 text-black">
                        ${item?.svc_price_amt}
                      </h4>
                      <p
                        className="text-red-500 text-sm m-0 cursor-pointer"
                        onClick={() => deleteCartItem(index)}
                      >
                        Delete
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="h-fit md:w-[30%] w-full pb-3">
            <div className="bg-gray-100 p-4 rounded-md">
              <h2 className="text-lg font-semibold">
                Selected Services Summary
              </h2>
              <div className="flex justify-between items-center mt-3">
                <p className="text-gray-500">Proposed Total</p>
                <p className="font-semibold">
                  ${total && Number(total)?.toFixed(2)}
                </p>
              </div>

              <div className="flex justify-between items-center mt-4">
                <p className="text-gray-500">Total</p>
                <p className="font-semibold">
                  ${total && Number(total)?.toFixed(2)}
                </p>
              </div>
            </div>

            <div className="mt-4 flex flex-col w-full justify-end gap-2">
              <button
                className="bg-[#1340CD] border border-gray-300 py-2 px-3 !rounded-md text-sm text-white"
                onClick={() => history.push(`/login`)}
              >
                Checkout
              </button>
              <button
                className="bg-white border border-gray-300 py-2 px-3 !rounded-md text-sm flex items-center justify-center gap-1"
                onClick={() => history.push(`/`)}
              >
                <BackIcon /> Go Back to Services
              </button>
            </div>
          </div>
        </div>
      ) : (
        <div className="flex gap-16 sm:!px-9 m-0 mt-5">
          {' '}
          <p className="text-red-500 w-full text-2xl font-semibold text-center">
            Your cart is empty!
          </p>
        </div>
      )}
    </WebsiteLayout>
  );
};

export default CartList;
